import A11yDialog from 'a11y-dialog';
import { menuFromHTML } from '@evermade/menu-toolkit';

function mobileMenu() {
	const config = window.emHeaderConfig;
	const menuEls = document.querySelectorAll('.js-mobile-menu');
	const modalEl = document.querySelector('.js-mobile-menu-modal');
	const toggleEls = document.querySelectorAll('.js-mobile-menu-toggle');
	const closeEls = document.querySelectorAll('.js-mobile-menu-close');

	const init = () => {
		const requiredEls = { modalEl };
		Object.keys(requiredEls).forEach((key) => {
			if (requiredEls[key] === null) {
				throw new Error(`Missing required el: ${key}`);
			}
		});

		setupMenus();

		const dialog = setupDialog(modalEl);
		setupModalCloseEvents(dialog);
		setupModalToggleEvents(dialog);
	};

	const setupMenus = () => {
		menuEls.forEach((menu) => {
			// Trying to prevent double initialization by Cookiebot
			if (menu.classList.contains('is-ready')) {
				return;
			}

			menuFromHTML(menu, {
				action: 'click',
				buttonIcon:
					'<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M5.66 8.04c-.2.09-.53.41-.63.62-.1.21-.09.48.01.7.12.26 6.34 6.48 6.6 6.6.23.1.49.1.72 0a158 158 0 0 0 6.6-6.6c.16-.36.07-.72-.27-1.07-.33-.33-.69-.41-1.05-.25-.14.07-.82.72-2.91 2.81L12 13.58l-2.73-2.73a39.02 39.02 0 0 0-2.91-2.8.87.87 0 0 0-.7-.02"/></svg>',
				expandChildMenuText: config.text.expandChildMenuText,
				shouldWrapAnchorToButton: false, // Force all sub-menu toggles to be buttons and not separate link + toggle
				openActiveSubMenuOnCreate: true,
				closeSubMenuOnOutsideClick: false,
			});
		});
	};

	const setupDialog = (targetModalEl) => {
		const dialog = new A11yDialog(targetModalEl);
		dialog.on('show', () => {
			document.body.classList.add('has-open-mobile-menu');
			Array.from(toggleEls).forEach((el) => {
				el.setAttribute('aria-expanded', 'true');
			});
		});
		dialog.on('hide', () => {
			document.body.classList.remove('has-open-mobile-menu');
			Array.from(toggleEls).forEach((el) => {
				el.setAttribute('aria-expanded', 'false');
			});
		});
		return dialog;
	};

	const setupModalToggleEvents = (dialog) => {
		Array.from(toggleEls).forEach((el) => {
			const { dataset } = el;
			// Classic Cookiebot BS. This prevents the event from being added multiple times
			if (!dataset.hasEvent) {
				el.addEventListener('click', (e) => {
					e.preventDefault();
					if (isModalOpen()) {
						dialog.hide();
					} else {
						dialog.show();
					}
				});
			}
			el.setAttribute('data-has-event', 'true');
		});
	};

	const setupModalCloseEvents = (dialog) => {
		Array.from(closeEls).forEach((el) => {
			const { dataset } = el;
			if (!dataset.hasEvent) {
				el.addEventListener('click', (e) => {
					e.preventDefault();
					dialog.hide();
				});
			}
			el.setAttribute('data-has-event', 'true');
		});
	};

	const isModalOpen = () => {
		return document.body.classList.contains('has-open-mobile-menu');
	};

	init();
}

export default mobileMenu;
